import { render, staticRenderFns } from "./clientSheet.vue?vue&type=template&id=3f5e2f9f&scoped=true"
import script from "./clientSheet.vue?vue&type=script&lang=js"
export * from "./clientSheet.vue?vue&type=script&lang=js"
import style0 from "./clientSheet.vue?vue&type=style&index=0&id=3f5e2f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e2f9f",
  null
  
)

export default component.exports